exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.project-list-search{position:absolute;left:0;top:0;width:100%;height:48px;background-color:#d8d8d8}.project-list-search .project-search-bar{width:calc(100% - 64px);height:32px;margin:8px 32px;border-radius:4px;background-color:#fff;display:flex}.project-list-search .project-search-bar .project-search-icon{background-image:url(" + require("../../../assets/images/search-icon.svg") + ");background-repeat:no-repeat;width:19px;height:19px;background-size:19px 19px;margin-top:6px;margin-left:10px}.project-list-search .project-search-bar .project-search-input{margin-left:11px;width:calc(100% - 45px);outline:none;border:none}.project-list-search .project-search-bar input::placeholder{font-family:Open Sans,sans-serif;font-weight:400;font-size:12px;color:#8b8b8b;font-style:normal}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/mobileWrappers/ProjectsListWrapper/ProjectListSearch/ProjectListSearch.scss
// module id = 1871
// module chunks = 0